import { z } from 'zod';

import {
  CursorPaginationMetaSchema,
  ListSortOrderSchema,
  PaginationSchema,
} from '../../../pagination.js';

import { CatalogItemStatusSchema } from './catalog-item-status.schema.js';
import { ServiceResponseSchema } from './service.schemas.js';

export const ServiceListSortFieldSchema = z.enum(['name', 'code', 'duration', 'status']);
export type ServiceListSortField = z.infer<typeof ServiceListSortFieldSchema>;

export const ListServicesQuerySchema = PaginationSchema.extend({
  q: z.preprocess(
    (val) => (typeof val === 'string' && val.trim() === '' ? undefined : val),
    z.string().trim().min(2).max(100).optional(),
  ),
  status: CatalogItemStatusSchema.optional(),
  categoryId: z.uuid().optional(),
  subcategoryId: z.uuid().optional(),
  sort: ServiceListSortFieldSchema.optional(),
  order: ListSortOrderSchema.optional(),
});

export const ListServicesResponseSchema = z.object({
  items: z.array(ServiceResponseSchema),
  pagination: CursorPaginationMetaSchema,
});

export type ListServicesQuery = z.infer<typeof ListServicesQuerySchema>;
export type ListServicesResponse = z.infer<typeof ListServicesResponseSchema>;
